import { faClose } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { APR_LABELS } from '@pickleballinc/lib/product-labels';
import { Application } from '@pickleballinc/lib/types';

import HeaderIcon from '../utils/headerIcon';
import { SwitcherOptionsInterface } from '../utils/nav.config';

interface HeaderLogoProps {
	application: Application;
	cdnUrl: string;
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
	switcherOptions: SwitcherOptionsInterface[];
}

export const HeaderLogo = ({ application, cdnUrl, isOpen, setIsOpen, switcherOptions }: HeaderLogoProps) => {
	const toggleDropdown = () => setIsOpen(!isOpen);
	const isTournament = application === 'tournament';
	const isTeamLeagues = application === 'team-leagues';
	const isAPRPage = application === 'apr-rankings';

	const selectedOption = switcherOptions.find(({ app }) => app === application);

	const src = isTournament
		? getCDNURL(`${cdnUrl}/global/PT.svg`, 45, 28)
		: isTeamLeagues
			? getCDNURL(`${cdnUrl}/global/PTL.svg`, 65, 40)
			: isAPRPage
				? getCDNURL(`${cdnUrl}/global/APR.svg`, 65, 40)
				: getCDNURL(`${cdnUrl}/${selectedOption?.img || 'global/PB.svg'}`, 45, 28);

	const width = isAPRPage ? 50 : 45;
	const height = isTournament ? 28 : isTeamLeagues ? 20 : isAPRPage ? 20 : 28;
	const alt = isTournament
		? 'Pickleballtournaments.com'
		: application === 'clubs'
			? 'Pickleballclubs.com'
			: application === 'leagues'
				? 'Pickleballleagues.com'
				: isTeamLeagues
					? 'Pickleballteamleagues.com'
					: isAPRPage
						? APR_LABELS.siteName
						: 'Pickleball.com';

	return (
		<div className="relative skew-x-3">
			<div
				className="flex-row items-center cursor-pointer flex"
				onClick={toggleDropdown}
				onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						toggleDropdown();
					}
				}}
				role="button"
				tabIndex={0}
			>
				<div className="hidden sm:flex !size-6 items-center justify-center">
					{isOpen ? <FontAwesomeIcon icon={faClose} size="lg" /> : <HeaderIcon />}
				</div>
				<h1 className="flex sm:hidden w-[65px] items-center justify-center">
					{!isOpen ? (
						<img src={src} width={width} height={height} alt={alt} className="z-40 skew-x-12" />
					) : (
						<FontAwesomeIcon icon={faClose} height={height} size="lg" />
					)}
				</h1>
				<h1 className="hidden !w-16 sm:flex justify-center items-center">
					<img src={src} width={width} height={height} alt={alt} className="z-40 skew-x-12" />
				</h1>
			</div>
		</div>
	);
};
